<template>
  <div class="headerWrapper">
    <div class="header">
      <div class="container">
        <el-row type="flex" justify="space-between" class="header-row" style="margin-top:0px">
          <el-col :span="2">
            <div align="left" style="padding-top:5px">
              <a href="/">
                <img style="width:110px" src="@/assets/img/logo.svg" alt="HumPoPG-logo">
              </a>
            </div>
          </el-col>
          <el-col :span="22">
            <ul class="nav-items">
              <li class="nav-item">
                <router-link active-class="active" to="/home">
                  Home
                </router-link>
              </li>
              <li class="nav-item">
                <router-link active-class="active" to="/article">
                  Article
                </router-link>
              </li>
              <li class="nav-item">
                <router-link active-class="active" to="/software">
                  Software
                </router-link>
              </li>
              <li class="nav-item">
                <router-link active-class="active" to="database">
                  Database
                </router-link>
              </li>
              <li class="nav-item">
                <router-link active-class="active" to="/consortia">
                  Consortia
                </router-link>
              </li>
              <li class="nav-item">
                <router-link active-class="active" to="/conference">
                  Conferences
                </router-link>
              </li>
              <li class="nav-item">
                <router-link active-class="active" to="/people">
                  People
                </router-link>
              </li>
              <li class="nav-item">
                <router-link active-class="active" to="/news">
                  News
                </router-link>
              </li>
              <li class="nav-item">
                <router-link active-class="active" to="/events">
                  Events
                </router-link>
              </li>
              <li class="nav-item">
                <router-link active-class="active" to="/about">
                  About
                </router-link>
              </li>
              <li class="nav-item">
                <router-link active-class="active" to="/conf">
                  <span class="text one">S</span>
                  <span class="text two">u</span>
                  <span class="text three">m</span>
                  <span class="text four">m</span>
                  <span class="text five">e</span>
                  <span class="text six">r</span>

                  <span class="text seven">S</span>
                  <span class="text eight">c</span>
                  <span class="text nine">h</span>
                  <span class="text ten">o</span>
                  <span class="text two">o</span>
                  <span class="text one">l</span>
                </router-link>
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { nginxURL, loginURL } from '@/utils/constants'
import gsap from 'gsap'

export default {
  name: 'Navbar',
  data() {
    return {
      activeIndex: '1',
      user: false,
      people: '',
      nginxURL: nginxURL,
      foldNavLink: false,
      loginURL
    }
  },
  mounted() {
    this.isFoldNavLink()
    const timeline = gsap.timeline({ repeat: -1 })
    const chars = document.querySelectorAll('.text')
    console.log(timeline)

    gsap.set('.one', { color: '#F86' })
    gsap.set('.two', { color: '#E74C3C' })
    gsap.set('.three', { color: '#F1C40F' })
    gsap.set('.four', { color: '#71C329' })
    gsap.set('.five', { color: '#27AE60' })
    gsap.set('.six', { color: '#E74C3C' })
    gsap.set('.seven', { color: '#5DBA45' })
    gsap.set('.eight', { color: '#F5B228' })
    gsap.set('.nine', { color: '#F5811A' })
    gsap.set('.ten', { color: '#DE3A3E' })

    timeline.from(chars, { opacity: 1, scale: 0, ease: 'sine', delay: 0.15 })
      .to('.text', {
        '--font-weight': 900,
        duration: 1.5,
        ease: 'sine.inOut',
        stagger: {
          yoyo: true,
          each: 0.1,
          repeat: -1
        }
      }, 1)
    window.onresize = () => {
      if (!this.timer) { // 使用节流机制，降低函数被触发的频率
        this.timer = true
        const that = this // 匿名函数的执行环境具有全局性，为防止this丢失这里用that变量保存一下
        setTimeout(function() {
          that.isFoldNavLink()
          that.timer = false
        }, 400)
      }
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath)
    },
    errorHandler() {
      return true
    },
    isFoldNavLink() {
      const w = window.innerWidth
      if (w < 993) {
        this.foldNavLink = true
      } else {
        this.foldNavLink = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@100..700&display=swap');

$google-font-roboto: "Roboto", sans-serif;
$google-font-source-sans-pro: "Source Sans Pro", sans-serif;
$roboto-mono: "Roboto Mono", monospace;

.active {
  background-color: #1f80ff !important;
  color: white !important;
  border-radius: 3px;
}

.nav-item > a {
  color: #1f80ff;
  font-weight: 650;
  padding: 4px 10px;
}
.text {
    color: #111;
    font-family: $roboto-mono;
    font-variation-settings: "wght" var(--font-weight, 600);
    font-size: 16px;
    font-weight: 800;
}
  .el-dropdown {
    vertical-align: top;
  }
  .el-dropdown + .el-dropdown {
    margin-left: 15px;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
.user-info {
  font-size: 14px;
  color: #909399;
  margin: 0 20px;
}
.avatar-img {
  border: 0.5px solid #F2F6FC;
}
.avatar-img:hover {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
  .el-dropdown-link {
    cursor: pointer;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
.avatar {
  text-align: right;
  margin-top: 10px;
}
  a {
     text-decoration: none
  }
  .headerWrapper {
    height: 70px;
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    z-index: 1500;
    display: block;
  }
  .header {
    height: 70px;
    background-color: #fff;
    box-shadow: 0 0.125rem 0.625rem -0.1875rem rgb(0 0 0 / 10%);
    color: #fff;
    top: 0;
    left: 0;
    width: 100%;
    line-height: 70px;
    z-index: 100;
    position: relative;
    display: block;
    margin: 0px;
  }

  .btn {
    display: block;
    float: right;
    margin-block-start: 1em;
    margin-block-end: 1em;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
  }
  .nav-items {
    height: 100%;
    line-height: 70px;
    background: transparent;
    padding: 0;
    margin: 0;
    display: block;
    text-align: right;
    list-style-type: disc;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
    /* text-align: center; */
    padding-left: 0px;
    -webkit-margin-before: 0em;
    margin-block-start: 0em;
    -webkit-margin-after: 0em;
    margin-block-end: 0em;

  }
  .nav-item {
    height: 100%;
    margin: 0;
    list-style: none;
    position: relative;
    cursor: pointer;
    display: inline-block;
    text-align: justify;
    line-height: 70px;
    padding: 0;
    margin: 0;
    margin: 0 5px;
    margin-top: 0px;
  }
  .header-row {
    line-height: 70px;
    width: 100%;
  }
  .nav-item .el-link {
    font-size: 16px;
  }
  .el-dropdown-link {
    cursor: pointer;
    /* color: #409EFF; */
  }
  .el-icon-arrow-down {
    font-size: 14px;
  }
  .el-dropdown {
    font-size: 16px;
  }
    .container {
    height: 100%;
    box-sizing: border-box;
    width: 1200px;
    display: block;
    margin: auto;
    text-align: center;
  }
  @media screen and (min-width: 1201px) {
    .container {width: 1200px}
  }

</style>
